var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "f898a79b-1922-435b-a2d3-cdf26a4e05c2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f24ebd4d-2820-4e61-b663-56be50b4ea8b",
    "data-name": "Component 2 2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#eab42b6b-9d37-4986-81cc-532cb72a60ff)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "b4436551-521c-43cd-9c94-6aec709e0b3e",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed318169-eac8-408f-a69c-f5d283892a9f",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eff4d1a7-7865-4d76-954a-3844a7f8dd91",
    "data-name": "Path 21",
    d: "M.124,25.8V.179H8.043q4.013,0,6.1,1.786A6.514,6.514,0,0,1,16.224,7.2a6.309,6.309,0,0,1-.862,3.361A5.085,5.085,0,0,1,13,12.621a4.485,4.485,0,0,1,2.657,1.98,6.78,6.78,0,0,1,.933,3.669,7.306,7.306,0,0,1-2.05,5.631,8.43,8.43,0,0,1-5.939,1.9ZM5.3,10.9H7.99q3.044,0,3.044-3.15a3.616,3.616,0,0,0-.7-2.5,3,3,0,0,0-2.288-.757H5.3Zm0,3.766v6.846H8.606a2.6,2.6,0,0,0,2.112-.862A3.71,3.71,0,0,0,11.44,18.2q0-3.448-2.5-3.537Z",
    style: {
      fill: "#5e5e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd542d30-98b6-492a-bc1e-e344ea300d7c",
    "data-name": "Path 22",
    d: "M29.829,14.715h-8.06v6.793h9.538V25.8H16.6V.179H31.272V4.491h-9.5v6.054h8.06Z",
    style: {
      fill: "#5e5e5e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "b6f7e460-c456-4227-a3d9-74dc4bb9e152",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f6ced003-7413-4e9f-bb9f-cf0c91812164",
    "data-name": "Path 23",
    d: "M49.222,25.8H44.048L36.481,9V25.8H31.307V.179h5.174L44.066,17V.179h5.156Z",
    style: {
      fill: "#ff00c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7fc716e-8445-4de1-98fe-8390f3edbf26",
    "data-name": "Path 24",
    d: "M58.724,8.979l3.449-8.8H68.1L62.086,12.885,68.245,25.8h-6l-3.519-8.957-3.5,8.957h-6l6.159-12.917L49.345.179h5.931Z",
    style: {
      fill: "#ff00c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bbd66f34-e337-4835-9010-235dc35077e7",
    "data-name": "Path 25",
    d: "M85.875,4.49H79.54V25.8H74.349V4.49h-6.23V.178H85.875Z",
    style: {
      fill: "#ff00c4"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxLogo);
export default __webpack_public_path__ + "static/media/bxLogo.344047ef68ef69a9e4ef7f05da6a68bc.svg";
export { ForwardRef as ReactComponent };